export default "__VITE_ASSET__4_iPhzaX__"